

function variantschange_image(variantfmid,productdata) {
  // console.log(productdata)
  // console.log(variantfmid)
  let medialist = productdata["media"]
  let variantslist = productdata["variants"]
  let mediaidlist = []
  variantslist.forEach(element => {
    if (element["featured_media"]) {
      
    if (element["featured_media"]["id"] == variantfmid){
      
    }else{
      mediaidlist.includes(element["featured_media"]["id"])?"":mediaidlist.push(element["featured_media"]["id"])
    }
    }
    
  });
  let mediaStartFlag = false;
  // $(".Product__Slideshow .flickity-slider .Product__SlideItem").remove()
  $(".Product__SlideshowNavScroller .Product__SlideshowNavImage").remove()
  $(".Product__SlideshowMobileNav .flickity-page-dots .dot").remove()
  let mobiecount = 0
  for (let i = 0; i < medialist.length; i++) {
    let selectFlag = false
    const element = medialist[i]
    if (element["id"]==variantfmid){
      mediaStartFlag = true;
      selectFlag = true;
    }
    if (mediaStartFlag){
      if(mediaidlist.includes(element["id"])){
        mediaStartFlag = false;
      }
    }
    if (mediaStartFlag){
      const isselected = selectFlag?"is-selected":"";
      const ismobieselected = mobiecount == 0?"is-selected":"";
      // selectFlag?$(".Product__SlideItem").removeClass("is-selected"):""
      // selectFlag?$("#Media"+element["id"]).addClass("is-selected"):""

      let MainImage = `<div id="Media${element["id"]}" tabindex="0" class="Product__SlideItem Product__SlideItem--image Carousel__Cell  ${isselected}" data-media-type="image" data-media-id="${element["id"]}" data-media-position="${mobiecount+1}" data-image-media-position="${mobiecount}" style="position: absolute; left: ${ mobiecount*100 }%;">
                        <div class="AspectRatio AspectRatio--withFallback" style="--aspect-ratio: ${element["aspect_ratio"]};">
                          <img class="Image--lazyLoad Image--fadeIn" data-src="${element["src"]+"&width={width}"}" data-widths="[200,400,600,700,800,900,1000,1200]" data-sizes="auto" data-expand="-100" alt="${escape(element["alt"])}" data-max-width="${element["width"]}" data-max-height="${element["height"]}" data-original-src="${element["src"]}">
                          <span class="Image__Loader"></span>
                        </div>
                      </div>`
      hrefurl = element["src"]+"&width=1024"
      imgurl = element["src"]+"&width=160"
      let imghtml = `<div data-media-id="${element["id"]}" class="Product__SlideshowNavImage AspectRatio ${isselected}" style="--aspect-ratio: ${element["aspect_ratio"]};cursor: pointer;">
                          <img src="${imgurl}" alt="${escape(element["alt"])}">
                        </div>`
      
      let mobiehtml = `<button type="button" aria-label="Show image ${element["position"]}" class="dot ${ismobieselected}" data-index="${i}"></button>`
      $(".Product__SlideshowNavScroller").append(imghtml)
      $(".Product__SlideshowMobileNav .flickity-page-dots").append(mobiehtml)
      // $(".Product__Slideshow .flickity-slider").append(MainImage)
      mobiecount++;
      // console.log(element)
    }
  }
}
